export default {
  paymentGateway: [],
  singlePaymentGateway: {},
};
